import moment from "moment";
let timeStemp = moment()
  .add(543, "years")
  .format("DD/MM/YYYY", true);
Array.prototype.insert = function(index, item) {
  this.splice(index, 0, item);
};

const printCar_Qeue = async function(data,car_coll) {
  //let DATA = data;
  console.log(data);
  let carQeue_list = [
    [
      { text: "ลำดับ", style: "tableHeader", alignment: "center", bold: true },
      {
        text: "รายชื่อลูกค้า",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
      {
        text: "วันเวลาเข้าเก็บ",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
      {
        text: "ขยะติดเชื้อ",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
      {
        text: "ขยะเคมี",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
      {
        text: "ขยะอันตราย",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
      {
        text: "ผู้ส่งมอบ",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
      {
        text: "ผู้รับมอบ",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
    ],
  ];
  for (let j = data.length - 1; j >= 0; j--) {
    carQeue_list.insert(1, [
      { text: j + 1, alignment: "center" },
      {
        text: data[j].CUS_NAME +'  '+ data[j].CUS_PHONE +' '+data[j].BILL_ID,
        alignment: "left",
      },
      {
        text: "",
        alignment: "center",
      },
      { text: "" },
      { text: "" },
      { text: "" },
      { text: "" },
      { text: "" },
      
    ]);
  }
  carQeue_list.push([
    { text:"", alignment: "center" },
    {
      text: "รวม",
      alignment: "center",
    },
    {
      text: "",
      alignment: "center",
    },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "" },
    
  ],
  [
    { text:"", alignment: "center" },
    {
      text: `ขึ้นรถ ${car_coll[0].CAR_NUMBER}`,
      alignment: "center",
    },
    {
      text: "",
      alignment: "center",
    },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "" },
    
  ],
  [
    { text:"", alignment: "center" },
    {
      text: `ขึ้นรถ ${car_coll[1].CAR_NUMBER}`,
      alignment: "center",
    },
    {
      text: "",
      alignment: "center",
    },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "" },
    
  ],
  [
    { text:"", alignment: "center" },
    {
      text: `ขึ้นรถ ${car_coll[2].CAR_NUMBER}`,
      alignment: "center",
    },
    {
      text: "",
      alignment: "center",
    },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "" },
    
  ],
  [
    { text:"", alignment: "center" },
    {
      text: "ลงโกดัง",
      alignment: "center",
    },
    {
      text: "",
      alignment: "center",
    },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "" },
    { text: "" },
    
  ],
  );
  const pdf = {
    //pageSize: 'A4',
    // pageMargins: [ 30, 0, 30, 0 ],
    footer(currentPage, pageCount) {
      return {
        columns: [
          // { text: "ท้ายกระดาษ", fontSize: 15, alignment: "center" },
          {
            text:
              "หน้าที่ " +
              currentPage.toString() +
              " จาก " +
              pageCount +
              " หน้า",
            margin: [5, 5, 15, 5],
            alignment: "right",
          },
        ],
      };
    },
    content: [
      {
        text: "คิวรถของ : " + data[0].CAR_NUM + "       หมายเหตุ : "   ,
        bold: true,
        style: "header",
      },

      {
        table: {
          widths: [20, 120, 50, 50,50,50, 50, 50],
          body: carQeue_list,
        },
      
        margin: [0, 0, 0, 10],
      },  
      // {
      //     text: "หมายเหตุ : " ,
      //     bold: true,
      //     style: "header",
      //     alignment: "left",
      //   },
    ],
    defaultStyle: {
      font: "THSarabunNew",
    },
    styles: {
      header: {
        fontSize: 18,
        alignment: "center",
        //bold: true
      },
      content: {
        fontSize: 16,
        alignment: "left",
        margin: [0, 10, 0, 0],
      },
      content_8: {
        fontSize: 16,
        alignment: "left",
        margin: [20, 10, 0, 0],
      },
      signature: {
        fontSize: 16,
        alignment: "center",
        margin: [0, 30, 0, 0],
      },
    },
  };
  return pdf;
};

// The "callback" argument is called with either true or false
// // depending on whether the image at "url" exists or not.
// function imageExists(url, callback) {
//   var img = new Image();
//   img.onload = function() { callback(true); };
//   img.onerror = function() { callback(false); };
//   img.src = url;
// }

// // Sample usage
// var imageUrl = 'http://www.google.com/images/srpr/nav_logo14.png';
// imageExists(imageUrl, function(exists) {
//   console.log('RESULT: url=' + imageUrl + ', exists=' + exists);
// });

// create function TH time
async function newDates(data) {
  // console.log(data);
  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);
  return a;
}
async function newTime(data) {
  //console.log(data);

  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);

  return a;
}
async function newTimeN(data) {
  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);
  return a;
}
function delimeter(data) {
  let y = parseFloat(data).toFixed(2);
  let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return x;
}
var d = new Date();
var dayNames = ["วัน อาทิตย์ ที่","วัน จันทร์ ที่","วัน อังคาร ที่","วัน พุทธ ที่","วัน พฤหัสบดี ที่","วัน ศุกร์ ที่","วัน เสาร์ ที่"];

export default printCar_Qeue;
